import { render, staticRenderFns } from "./SectionCollaboratori.vue?vue&type=template&id=0c750d6d&scoped=true&"
import script from "./SectionCollaboratori.vue?vue&type=script&lang=js&"
export * from "./SectionCollaboratori.vue?vue&type=script&lang=js&"
import style0 from "./SectionCollaboratori.vue?vue&type=style&index=0&id=0c750d6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c750d6d",
  null
  
)

export default component.exports